export * from "react-native-mmkv";
export { default } from "react-native-mmkv";
// Shadow the upstream `createMMKV` with an SSR-safe variant: on the web server
// (no DOM) it returns an in-memory instance instead of throwing "Tried to access
// storage on the server" (see `create-mmkv-ssr-safe.ts`). An explicit named export
// wins over the `export *` re-export of the same name, so every importer of
// `@-/com.npmjs.react-native-mmkv` transparently gets the guarded version.
export { createMMKV } from "#create-mmkv-ssr-safe";
